import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/common/Elements/Elements';

import classes from './BodyTime.module.scss';

const BodyTime = ({ data }) => {
  const optionsForData = Object.keys(data);

  return (
    <section className={classes.wrap}>
      <Text type={'p'} className={classes.title} weight="m">
        Time
      </Text>
      {optionsForData.map(item => (
        <div className={classes.notifWrap} key={item}>
          <Text type={'p'} className={classes.name} weight="m">
            {`${item}`}
          </Text>

          <Text className={classes.days} weight="m">
            {data[item].join(', ')}
          </Text>
        </div>
      ))}
    </section>
  );
};

BodyTime.propTypes = {
  data: PropTypes.object
};

export default BodyTime;
